import taxRechargeOrderApi from "@/api/taxRechargeOrderApi";

const taxRechargeOrderStore = {
  namespaced: true,
  state: {
    declareList: [],
  },
  mutations: {
    setDeclareList(state, data) {
      state.declareList = data;
    },
  },
  actions: {
    pageQuery({ commit }, data) {
      return taxRechargeOrderApi.pageQuery(data).then((res) => {
        //commit("setDeclareList", res.result);
        return res;
      });
    },
    add({ commit }, data) {
      return taxRechargeOrderApi.add(data).then((res) => {
        return res;
      });
    },
    edit({ commit }, data) {
      return taxRechargeOrderApi.edit(data).then((res) => {
        return res;
      });
    },
    audit({ commit }, data) {
      return taxRechargeOrderApi.audit(data).then((res) => {
        return res;
      });
    },
    listOperateLog({ commit }, data) {
      return taxRechargeOrderApi.listOperateLog(data).then((res) => {
        return res;
      });
    },
    submitTaxRechargeBuildExcelTask({ commit }, data) {
      return taxRechargeOrderApi
        .submitTaxRechargeBuildExcelTask(data)
        .then((res) => {
          return res;
        });
    },
  },
};

export default taxRechargeOrderStore;
